import {Loader} from '@mantine/core';
import router from 'next/router';
import {COMMUNITY} from '../../../../config/constants/routes';
import {INITIAL_TAG_LIST} from '../../../../core/entities/community/constants';
import {useGetCommunityTagList} from '../../../../core/repositories/communityRepository';

type Props = {
  selectedTagId?: string;
};

export const TagList: React.FC<Props> = ({selectedTagId}) => {
  const {
    data: communityPopularTagList,
    isLoading: isCommunityPopularTagListLoading,
  } = useGetCommunityTagList({
    isPopular: true,
  });

  return (
    <div className="bg-white rounded-12 shadow-modal">
      <>
        <p className="text-base text-black-1 font-bold leading border-b-[1px] border-line border-collapse p-12">
          カテゴリー
        </p>
        <ul className="px-8 pb-8">
          {communityPopularTagList?.ok && !isCommunityPopularTagListLoading ? (
            <>
              {[
                ...INITIAL_TAG_LIST,
                ...communityPopularTagList.value.communityTags,
              ].map((tag) => (
                <li className="border-b-[1px] border-line border-collapse [&:nth-last-child(1)]:border-b-0">
                  <TagItem
                    tag={{id: String(tag.id), name: tag.name}}
                    selectedTagId={selectedTagId ?? ''}
                  />
                </li>
              ))}
            </>
          ) : (
            <div className="flex justify-center items-center h-[150px]">
              <Loader color="gray" />
            </div>
          )}
        </ul>
      </>
    </div>
  );
};

const TagItem: React.FC<{
  tag: {id: string; name: string};
  selectedTagId: string;
}> = ({tag, selectedTagId}) => {
  if (selectedTagId === tag.id) {
    return (
      <div className="py-4 px-8 text-base text-white leading bg-primary-3 rounded-[8px]">
        {tag.name}
      </div>
    );
  }

  return (
    <button
      onClick={async () => {
        await router.push(`${COMMUNITY}?tag=${tag.id}`);
      }}
      className="py-4 px-8 w-full text-base text-black-1 leading text-left hover:opacity-80"
    >
      {tag.name}
    </button>
  );
};
